import styled from 'styled-components';

export const MapStyled = styled.div`
  height: calc(100% - 7.5rem);
  width: 100%;
`;
